import { ArrowForwardIos } from '@interhyp/platform-icons';
import classnames from 'classnames';
import React, { forwardRef } from 'react';
import { IconRenderer } from "../../helper/components/IconRenderer.js";
import styles from "./Link.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Link = /*#__PURE__*/forwardRef(({
  inline,
  className,
  onClick,
  secondary,
  disabled,
  children,
  inputRef,
  isBackLink,
  icon,
  ...rest
}, ref) => {
  const Component = disabled ? 'span' : 'a';
  const classes = classnames(styles.link, {
    [styles.inline]: inline,
    [styles.secondary]: secondary,
    [styles.disabled]: disabled,
    [styles.isBackLink]: isBackLink,
    [styles.customIcon]: !!icon
  }, className);
  const commonProps = {
    rel: !disabled ? 'noopener' : undefined,
    onClick: !disabled ? onClick : undefined,
    className: classes,
    ...rest
  };
  const linkIcon = inline ? null : /*#__PURE__*/_jsx(IconRenderer, {
    icon: icon ?? ArrowForwardIos,
    size: icon ? 'DEFAULT' : 'SMALL',
    className: classnames({
      [styles.left]: !icon && isBackLink
    })
  });
  return /*#__PURE__*/_jsxs(Component, {
    ...commonProps,
    ref: ref ?? inputRef,
    children: [children, linkIcon]
  });
});